<template>
    <div class="my-3">
        <GoodTable
            :rows="rows"
            :columns="columns"
            :totalPage="totalPage"
            :page="page"
            :sortField="sortField"
            :lineNumbers="lineNumbers"
            :selectOption="selectOption"
            :noneBorder="noneBorder"
            :nodata="nodata"
            height="500px"
            @pagination="changePage($event)"
        >
            <template v-slot:customPagination>
              <div class="text-right mb-1 mt-2">
                {{ showIndex() }}
                <v-btn
                  small
                  class="pagination-btn-left"
                  @click="
              () => {
                page--;
              }
            "
                  :disabled="page == 1"
                >
                  <v-icon>mdi-menu-left</v-icon>
                </v-btn>
                <v-btn
                  :disabled="(rows.length < limit)"
                  small
                  class="pagination-btn-right"
                  @click="
              () => {
                page++;
              }
            "
                >
                  <v-icon>mdi-menu-right</v-icon>
                </v-btn>
              </div>
            </template>
            <template #status="item">
                <span
                    :style="{background: checkStatusTicket(item.status) && checkStatusTicket(item.status).color ? checkStatusTicket(item.status).color : '#f1f1f1'}"
                    style="padding:5px 10px; border-radius:5px; color:#FFFFFF;"
                    class="text-no-wrap"
                >
                    {{ item.status.name }}
                </span>
            </template>
            <template #action="item">
                <div class="d-flex justify-center">
                    <button
                        class="btn btn-sm btn-primary"
                        @click="handleViewTicket(item._id)"
                    >
                        <img src="../assets/send-icon.svg" alt="">
                    </button>
                </div>
            </template>
    </GoodTable>
    </div>
</template>

<script>
import StudentCareServices from '@/services/StudentCareServices';
import { mapActions, mapState } from 'vuex';
import GoodTable from '../../../components/common/GoodTable.vue';

export default {
  components: { GoodTable },
  props: {
    contact: {
      type: Object,
      defautl: () => {},
    },
  },
  data() {
    return {
      rows: [],
      columns: [
        {
          label: 'Người tạo',
          field: 'createdBy.username',
          thWidth: '220px',
        },
        {
          label: 'Ngày tạo',
          field: 'createdAt',
          type: 'date',
          format: 'DD-MM-YYYY',
          tdClass: 'text-center',
          thWidth: '220px',
        },
        {
          label: 'Nhóm ticket',
          field: 'template.groupTicketName',
          thWidth: '450px',
        },
        {
          label: 'Loại ticket',
          field: 'template.typeTicketName',
          thWidth: '300px',
        },
        {
          label: 'Trạng thái xử lý',
          field: 'status',
          customRow: true,
          thWidth: '220px',
          tdClass: 'text-center',
        },
        {
          label: '',
          field: 'action',
          customRow: true,
          thWidth: '32px',
        },
      ],
      totalPage: null,
      page: 1,
      sortField: {},
      lineNumbers: {},
      selectOption: false,
      pagination: true,
      height: '',
      noneBorder: true,
      limit: 10,
      nodata: 'Học viên hiện tại chưa có ticket !',
    };
  },
  async created() {
    await this.getListTicket();
    this.getListTicketStatus();
  },
  computed: {
    ...mapState('ticket', ['listTicketStatus']),
  },
  methods: {
    ...mapActions('ticket', ['getListTicketStatus']),
    showIndex() {
      if (this.rows.length > 0) {
        // eslint-disable-next-line radix
        const maxIndex = this.rows.length < this.limit ? parseInt(this.page - 1) * parseInt(this.limit) + this.rows.length : parseInt(this.page) * parseInt(this.limit);
        // eslint-disable-next-line radix
        return this.rows.length < this.limit ? `${maxIndex - parseInt(this.rows.length) + 1} - ${maxIndex}` : `${maxIndex - parseInt(this.limit) + 1} - ${maxIndex}`;
      }
      return ('0 - 0');
    },
    handleViewTicket(id) {
      const routeData = this.$router.resolve({ name: 'Ticket', query: { ticketId: id } });
      window.open(routeData.href, '_blank');
    },
    async getListTicket() {
      const params = {
        customerCode: this.contact.contact_code,
        limit: this.limit,
        page: this.page,
      };
      const res = await StudentCareServices.fgGetListTicketCrm(params);
      if (res) {
        this.rows = res.data;
        // this.totalPage = res.pagination.totalPage;
        // this.page = res.pagination.pageCurrent;
      }
    },
    changePage(page) {
      this.page = page;
      this.getListTicket();
    },
    checkStatusTicket(status) {
      const statusT = this.listTicketStatus.find((item) => item.value === status.name);
      return statusT;
    },
  },
};
</script>

<style>
</style>
